import { Component, OnInit, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { TypedFormBuilder } from 'ZalamoLibrary/src/lib/ui/form/TypedFormBuilder';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { filter, tap } from 'rxjs/operators';
import { NgControl } from '@angular/forms';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';

@Component({
    selector: 'lib-box-shadow-single-shadow',
    templateUrl: './box-shadow-single-shadow.component.html',
    styleUrls: ['./box-shadow-single-shadow.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoxShadowSingleShadowComponent
  extends AbstractValueAccessor
  implements OnInit
{
  model = this.form.typedGroup<{
    shiftX: number;
    shiftY: number;
    spread: number;
    blur: number;
    color: string;
  }>({
    blur: [0],
    color: ['rgba(255,255,255,1)'],
    shiftX: [0],
    shiftY: [0],
    spread: [0],
  });

  constructor(
    private form: TypedFormBuilder,
    @Self()
    @Optional()
    private ngControl: NgControl
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    let updateInProgress = false;
    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        filter(() => !updateInProgress),
        RxjsOperators.filterTruthy(),
        tap((x) => {
          const [shiftX, shiftY, blur, spread, color] = x
            .replace(/px/g, '')
            .split(' ');
          updateInProgress = true;

          this.model.patchValue({
            shiftX,
            shiftY,
            blur,
            spread,
            color,
          });
          updateInProgress = false;
        })
      ),
      this.model.valueChanges.pipe(
        filter(() => !updateInProgress),
        tap(({ shiftX, shiftY, blur, spread, color }) => {
          console.log(`${shiftX}px ${shiftY}px ${blur}px ${spread}px ${color}`);
          updateInProgress = true;
          this.writeValue(
            `${shiftX}px ${shiftY}px ${blur}px ${spread}px ${color}`
          );
          updateInProgress = false;
        })
      )
    );
  }
}
